import type { JSX } from 'react'
import type { IVodSimpleCard } from './VodSimpleCard'

import { CardType } from 'blocks/Cards/Card.h'
import {
  topNumberToPicture,
  VodHorizontalNumberSC,
  VodVerticalNumberSC,
} from 'blocks/Cards/TopNumbers'
import { getCardASpectRatio } from './lib'
import { TopVodSimpleCardSC } from './TopVodSimpleCard.styled'
import { VodSimpleCard } from './VodSimpleCard'

export interface ITopVodSimpleCard extends IVodSimpleCard {
  topNumber: number
}

export const TopVodSimpleCard = ({
  topNumber,
  type,
  onClick,
  ...rest
}: ITopVodSimpleCard): JSX.Element => {
  const TopNumberPicture = topNumberToPicture[topNumber] ?? null

  const cardAspectRatio = getCardASpectRatio(type)
  const NumberSC =
    type === CardType.HORIZONTAL ? VodHorizontalNumberSC : VodVerticalNumberSC

  return (
    <TopVodSimpleCardSC aspectRatio={cardAspectRatio} onClick={onClick}>
      <NumberSC>
        <TopNumberPicture />
      </NumberSC>

      <VodSimpleCard type={type} {...rest} />
    </TopVodSimpleCardSC>
  )
}
